import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import audio from './audio';
import routeParamConstants from './routeParamConstants';
import QueryParamsProxy from './queryParamProxy';
var showModal = function showModal(modalType) {
  audio.onClick();
  QueryParamsProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_MODAL, modalType));
};
export default showModal;